module.exports = __webpack_public_path__ + "b3inventory.0d14309ca6d8a49d2093.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/yardobject/font/b3inventory.eot?14714644
// module id = 248
// module chunks = 3